import { createSelector } from 'reselect';

const getLogState = (state) => state.log;

const isManualLogOpened = createSelector(getLogState, (logState) => logState.manualLogOpened);

const isManualTaskOpened = createSelector(getLogState, (logState) => logState.manualTaskOpened);

const isCancellationLogOpened = createSelector(
  getLogState,
  (logState) => !!logState.cancellationLogOpened
);

const isLogEditableAfterCreation = createSelector(
  getLogState,
  (_, logId) => ({ logId }),
  (logState, { logId }) => {
    return !!logState && !!logState.editableAfterCreation && logState.editableAfterCreation[logId];
  }
);

const getCancellationLog = createSelector(
  getLogState,
  (logState) => logState.cancellationLogOpened
);

const getManuallyLogsCreated = createSelector(getLogState, (logState) => logState.creatingLogs);

const getLogs = createSelector(getLogState, (logState) => [...logState.logs.values()]);

const getTotalLogs = createSelector(getLogState, (logState) => logState.totalLogs);

const getIsLoading = createSelector(getLogState, (logState) => logState.loading);
const getIsLoadingNextPage = createSelector(getLogState, (logState) => logState.loadingNextPage);
const getNextLogsPageLink = createSelector(getLogState, (logState) => logState.nextLink);

export {
  isManualLogOpened,
  isManualTaskOpened,
  isCancellationLogOpened,
  getCancellationLog,
  getManuallyLogsCreated,
  getLogs,
  getTotalLogs,
  getIsLoading,
  getIsLoadingNextPage,
  isLogEditableAfterCreation,
  getNextLogsPageLink,
};
